
(function() {
  var PREORDER_PRODUCTS = [10093519372589, 8388961239341, 8388951933229];
  var PREORDER_MSG = 'Ships approx 10th November';

  document.addEventListener('submit', function(e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;
    var action = form.getAttribute('action') || '';
    if (action.indexOf('/cart/add') === -1) return;

    var match = window.location.pathname.match(/\/products\/([^/?]+)/);
    if (!match) return;

    fetch('/products/' + match[1] + '.js')
      .then(function(r) { return r.json(); })
      .then(function(product) {
        if (PREORDER_PRODUCTS.indexOf(product.id) === -1) return;
        var existing = form.querySelector('input[name="properties[Delivery]"]');
        if (existing) { existing.value = PREORDER_MSG; return; }
        var input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'properties[Delivery]';
        input.value = PREORDER_MSG;
        form.appendChild(input);
      });
  }, true);
})();
